import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '@/features/auth'
import { useButtonNavigateClick } from '@/hooks/useButtonNavigateClick'

export const useLogout = () => {
  const auth = useAuth()
  const navigate = useNavigate()

  return async () => {
    await auth.logout()
    navigate('/auth/login')
  }
}

export const useOpenHomePage = (isLoggedIn: boolean) => {
  return useButtonNavigateClick(isLoggedIn ? '/dashboard' : '/')
}

export const useOpenLogIn = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const link = useMemo(() => {
    const loginRoute = '/auth/login'
    const redirectPath = pathname !== loginRoute ? pathname : '/'
    return loginRoute + (redirectPath ? `?login_redirect=${redirectPath}` : '')
  }, [pathname])

  return () => navigate(link)
}
